import { useEffect, useState } from "react";
import ArticleBody from "@/components/blog/ArticleBody";
import logo from "@/assets/logo-abillyting-v2.jpeg.asset.json";

export const PREVIEW_KEY = "abb-article-preview";
type PreviewData = { title: string; category: string | null; publishedAt: string | null; coverUrl: string | null; content: string };

/** Rendered inside an iframe by the admin editor so device widths use real breakpoints. */
const BlogPreview = () => {
  const [data, setData] = useState<PreviewData | null>(null);
  useEffect(() => {
    const read = () => {
      try { setData(JSON.parse(localStorage.getItem(PREVIEW_KEY) ?? "null")); } catch { setData(null); }
    };
    read();
    window.addEventListener("storage", read);
    return () => window.removeEventListener("storage", read);
  }, []);

  if (!data) return <p className="p-8 text-muted-foreground">Nada para pré-visualizar.</p>;
  return (
    <main className="min-h-screen bg-background">
      <header className="border-b border-border bg-background/95">
        <div className="container mx-auto px-4 py-4">
          <img src={logo.url} alt="Abillyting Marketing" className="h-12 md:h-16 w-auto object-contain" />
        </div>
      </header>
      <article className="container mx-auto px-4 py-10 md:py-16 max-w-3xl">
        <ArticleBody title={data.title} category={data.category} publishedAt={data.publishedAt} coverUrl={data.coverUrl} content={data.content} preview />
      </article>
    </main>
  );
};

export default BlogPreview;
